import React, { forwardRef } from 'react';
import Menu from '@hud/web-components/Menu/Menu';
import { HudIcon, IconType } from '@hud/web-components/Icons/HudIcons';
import MenuButton from '@hud/web-components/Menu/MenuButton';
import { ConfirmationPopover } from '@hud/web-components/Popover/ConfirmationPopover';
import Styled from './SelectMyServicesMenu.styles';
import useAnalytics from '../../hooks/useAnalytics';
import { Events } from '../../analytics';

interface MenuItemProps extends React.ComponentPropsWithoutRef<'div'> {
  icon: IconType;
  text?: string;
  analyticsEvent: keyof Events;
}

export default function SelectMyServicesMenu({
  allSelected,
  serviceIds,
  onSelect,
}: {
  allSelected: boolean;
  serviceIds: number[];
  onSelect: (ids: number[], isSingleService: boolean) => void;
}) {
  const analytics = useAnalytics();

  const MenuItem = forwardRef<HTMLDivElement, MenuItemProps>(
    ({ icon, text, analyticsEvent, ...props }, ref) => (
      <Styled.MenuItem
        ref={ref}
        {...props}
        onClick={(e) => {
          analytics.capture(analyticsEvent);
          if (props.onClick) props.onClick(e);
        }}
      >
        <HudIcon icon={icon} size="20px" />
        {text}
      </Styled.MenuItem>
    ),
  );

  return (
    <Styled.Container>
      <Menu.Menu>
        <Menu.Target>
          <div>
            <MenuButton>
              <HudIcon
                icon={allSelected ? 'other.starActive' : 'other.star'}
                size="20px"
              />
              <Styled.Icon icon="menu.caretDown" size="14px" />
            </MenuButton>
          </div>
        </Menu.Target>
        <Menu.Dropdown>
          <ConfirmationPopover
            text="Are you sure you want to select all services in this page?"
            confirmationLabel="Select"
            onSubmit={() => onSelect(serviceIds, false)}
          >
            <MenuItem
              icon="other.starActive"
              text="Select all in this page"
              analyticsEvent={'services_select_all_clicked'}
            />
          </ConfirmationPopover>


          <ConfirmationPopover
            text="Are you sure you want to unselect all services in this page?"
            confirmationLabel="Unselect"
            onSubmit={() => onSelect([], false)}
          >
            <MenuItem
              icon="other.star"
              text="Unselect all in this page"
              analyticsEvent={'services_unselect_all_clicked'}
            />
          </ConfirmationPopover>

        </Menu.Dropdown>
      </Menu.Menu>
    </Styled.Container>
  );
}
